import { render } from "./DropFielitem.vue?vue&type=template&id=7abefde8"
import script from "./DropFielitem.vue?vue&type=script&lang=js"
export * from "./DropFielitem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\game\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__